/**
 * Shared display config for the SA-270 mission queue lane (`queue_state` /
 * `waiting_on` on Order). Lives in its own module — not on OrdersPage —
 * because more than one surface renders these (OrdersPage list, plus the
 * inbox/detail surfaces added in the SA-270 follow-on task).
 * `dot` (SA-468) is the wash's hue at full strength, for the register's
 * QUEUE filter.
 */

import type { QueueState, WaitingOn } from '@/types/commerce'

export const QUEUE_STATE_CONFIG: Record<QueueState, { label: string; className: string; dot: string }> = {
  return_for_information: {
    label: 'Return for info',
    className: 'bg-accent-orange/10 text-accent-orange',
    dot: 'bg-accent-orange',
  },
  potential_duplicate: {
    label: 'Potential duplicate',
    className: 'bg-warning/10 text-warning-strong',
    dot: 'bg-warning',
  },
  reuse_delta_analysis: {
    label: 'Reuse/delta',
    className: 'bg-accent-indigo/10 text-accent-indigo',
    dot: 'bg-accent-indigo',
  },
  ready_for_dispatch_analysis: {
    label: 'Ready for analysis',
    className: 'bg-info/10 text-info',
    dot: 'bg-info',
  },
  awaiting_specialist_input: {
    label: 'Awaiting specialist',
    className: 'bg-accent-purple/10 text-accent-purple',
    dot: 'bg-accent-purple',
  },
  blocked_decision_required: {
    label: 'Blocked/decision',
    className: 'bg-destructive/10 text-destructive',
    dot: 'bg-destructive',
  },
}

export const WAITING_ON_LABELS: Record<WaitingOn, string> = {
  customer: 'Customer',
  commercial: 'Commercial',
  specialist: 'Specialist',
  dispatch: 'Dispatch',
}

/** SA-1175: the one check the register seeds `?waiting_on=` through — only a
 *  role the server accepts (anything else is its 400) ever becomes a filter. */
export const isWaitingOn = (v: unknown): v is WaitingOn =>
  typeof v === 'string' && Object.hasOwn(WAITING_ON_LABELS, v)
